import { render, staticRenderFns } from "./MLCNotificationLog.vue?vue&type=template&id=5929f796"
import script from "./MLCNotificationLog.vue?vue&type=script&lang=js"
export * from "./MLCNotificationLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports